import { OfflineDisabled } from '@amplitude/analytics-types'

import { ampli } from '@Analytics/ampli'
import { Config } from '@Analytics/config'
import {
  baseAttributeEnrichment,
  inViewEnrichment,
  normalizationAttributeEnrichment,
  pageViewTrackingEnrichment,
  pauseEventStreamPlugin,
  waitForIdentifyEnrichment,
} from '@Analytics/plugins'
import { upsertSplitTestsHistory } from '@Globals/SplitTests/History'

let initialized = false

export function init(config: Config) {
  if (typeof window === 'undefined') {
    return
  }

  if (initialized) {
    return
  }

  initialized = true

  upsertSplitTestsHistory(config.splitTests)

  // in order to add plugins before the first events are sent, we must not wait for the load call to finish via promises
  ampli.load({
    client: {
      configuration: {
        defaultTracking: {
          attribution: false,
          fileDownloads: false,
          formInteractions: false,
          pageViews: true,
          sessions: true,
        },
        offline: OfflineDisabled,
      },
    },
    environment: process.env.NODE_ENV === 'production' ? 'production' : 'development',
  })

  ampli.client.add(pauseEventStreamPlugin())
  ampli.client.add(waitForIdentifyEnrichment())
  ampli.client.add(baseAttributeEnrichment(config))
  ampli.client.add(pageViewTrackingEnrichment(config))
  ampli.client.add(inViewEnrichment())
  ampli.client.add(normalizationAttributeEnrichment())

  // attempt to flush all events in the background when navigating away
  window.addEventListener('pagehide', () => {
    ampli.client.setTransport('beacon')
    ampli.flush()
  })
}
